var map = {
	"./axj-competition-club-api.js": "xB8Z",
	"./axj-extra-show-club-api.js": "vtxn"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6iHY";


//////////////////
// WEBPACK FOOTER
// ./src/api/axj-extracurricular -api.js$
// module id = 6iHY
// module chunks = 1